import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const Authentication: React.FC = () => {
  return (
    <PageTemplate
      title="Authentication"
      description="Manage authentication settings for your org"
    />
  );
};